import React, { useState } from 'react'
import styled from 'styled-components'
import SearchBar from '../molecules/Navbar/Searchbar';
import Notification from '../molecules/Navbar/Notification';
import ProfileSection from '../molecules/Navbar/ProfileSection';
import { image } from '../../app/utils/common/image';
import { useAppDispatch, useAppSelector } from '../../app/utils/hooks/reduxHook';
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { useLocation, useNavigate } from 'react-router-dom';
import { excellDownloadUserAPI, getAllUsersAPI } from '../../redux/API/AllUsersAPI';
import { setAllUsersLoading } from '../../redux/Slices/allUsersSlice';
import { setBrokerLoading } from '../../redux/Slices/brokerSlice';
import { excellDownloadBrokerAPI, getAllBrokers } from '../../redux/API/BrokerAPI';
import { setManagerLoading, setManagerPagination } from '../../redux/Slices/managerSlice';
import { excellDownloadManagerAPI, getAllManagers } from '../../redux/API/ManagerAPI';
import { getImageURL } from '../../app/utils/common/getImageUrl';
import { showErrorToast } from '../../app/utils/common/Toast';
const NavbarContainer = styled.div`

position:relative;
width:98%;
display:flex;
align-items:center;
justify-content:space-between;
margin-left:24px;
@media screen and (max-width: 1000px) {
        display: none;
    }
`
const ProfilerContainer = styled.div`

// position:absolute;
top:30px;
right:20px;
height:50px;
display:flex;
flex-direction:row;
margin-right:25px;
`
const SearchBarContainer = styled.div`
// position:absolute;
top:30px;
left:10px;
`;
const Navbar: React.FC = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const path = location.pathname;
    const { loading } = useAppSelector((state) => state.allUsers);
    const { loading: brokerLoading } = useAppSelector((state) => state?.broker)
    const {loading: managerLoading} = useAppSelector((state)=> state?.manager)

    const exportAllUsers = async () => {
        dispatch(setAllUsersLoading(true));
        dispatch(excellDownloadUserAPI({ role_id: 2 })).then((res: any) => {
            if (res?.payload?.fileUrl) {
                window.open(getImageURL(res?.payload?.fileUrl), "_blank");
                dispatch(setAllUsersLoading(false));
            }
        }).catch((err) => {
            showErrorToast('Export failed or timed out');
            dispatch(setAllUsersLoading(false));
        }).finally(() => {
            dispatch(setAllUsersLoading(false));
        })
    };

    const exportAllBrokers = async () => {
        dispatch(setBrokerLoading(true));
        dispatch(excellDownloadBrokerAPI()).then((res: any) => {
            if (res?.payload?.fileUrl) {
                window.open(getImageURL(res?.payload?.fileUrl), "_blank");
                dispatch(setBrokerLoading(false));
            }
        }).catch((err) => {
            showErrorToast('Export failed or timed out');
            dispatch(setBrokerLoading(false));
        }).finally(() => {
            dispatch(setBrokerLoading(false));
        })
    }

    const exportAllManagers = async () => {
        dispatch(setManagerLoading(true));
        dispatch(excellDownloadManagerAPI()).then((res: any) => {
            if (res?.payload?.fileUrl) {
                window.open(getImageURL(res?.payload?.fileUrl), "_blank");
                dispatch(setManagerLoading(false));
            }
        }).catch((err) => {
            showErrorToast('Export failed or timed out');
            dispatch(setManagerLoading(false));
        }).finally(() => {
            dispatch(setManagerLoading(false));
        })
    };
    
    return (
        <NavbarContainer>
            <SearchBarContainer>
                <SearchBar />
            </SearchBarContainer>
            <ProfilerContainer>
                {path === '/dashboard/all-users' && <div onClick={!loading? exportAllUsers: undefined} style={{ marginRight: "20px", marginTop: "10px", cursor: "pointer" }}>
                    <img style={{height: "34px", width: "40px",}}  src={image.EXCEL_ICON} className='excel-icon get-help-icon' />
                    {/* <div className="get-help-excel"> Export as Excel </div> */}
                </div>}

                {path === '/dashboard/manage-broker' && <div onClick={!brokerLoading? exportAllBrokers: undefined} style={{ marginRight: "20px", marginTop: "10px", cursor: "pointer" }}>
                    <img style={{height: "34px", width: "40px",}} src={image.EXCEL_ICON} className='excel-icon get-help-icon' />
                </div>}

                {path === '/dashboard/manage-manager' && <div onClick={!managerLoading? exportAllManagers: undefined} style={{ marginRight: "20px", marginTop: "10px", cursor: "pointer" }}>
                    <img style={{height: "34px", width: "40px",}}  src={image.EXCEL_ICON} className='excel-icon get-help-icon' />
                </div>}

                <Notification />
                <ProfileSection />
            </ProfilerContainer>
        </NavbarContainer>
    )
}

export default Navbar